import { createBrowserRouter, Navigate, RouteObject } from "react-router-dom";
import Login from "./pages/LandingPage/Login/Login";
import AppLayout from "./layouts/AppLayout";
import SystemServices from "./pages/SystemDashboard/Services/SystemServices";
import SystemBranches from "./pages/SystemDashboard/Branches/SystemBranches";
import SystemHome from "./pages/SystemDashboard/Home/SystemHome";
import SystemDashboardLayout from "./layouts/SystemDashboardLayout";
import CustomerDashboardLayout from "./layouts/CustomerDashboardLayout";
import BranchCreate from "./pages/SystemDashboard/Branches/BranchCreate";
import BranchUpdate from "./pages/SystemDashboard/Branches/BranchUpdate";
import SystemUsers from "./pages/SystemDashboard/Users/SystemUsers";
import UserInvite from "./pages/SystemDashboard/Users/UserInvite";
import Register from "./pages/LandingPage/Register/Register";
import SystemChatBot from "./pages/SystemDashboard/ChatBot/SystemChatBot";
import SystemProfile from "./pages/SystemDashboard/SystemProfile/SystemProfile";
import ServiceCreate from "./pages/SystemDashboard/Services/ServiceCreate";
import ServiceUpdate from "./pages/SystemDashboard/Services/ServiceUpdate";
import ForgotPassword from "./pages/LandingPage/ForgotPassword/ForgotPassword";
import SystemTranslations from "./pages/SystemDashboard/SystemTranslations/SystemTranslations";
import Layout from "./pages/LandingPage/Layout/Layout";
import Branches from "./pages/LandingPage/Branches/Branches";
import Services from "./pages/LandingPage/Services/Services";
import OrderCreate from "./pages/LandingPage/Orders/OrderCreate";
import SystemLiveChat from "./pages/SystemDashboard/LiveChat/SystemLiveChat";
import SystemOrders from "./pages/SystemDashboard/Orders/SystemOrders";
import DashboardProfile from "./pages/CustomerDashboard/Profile/DashboardProfile";
import DashboardOrders from "./pages/CustomerDashboard/Orders/DashboardOrders";
import SystemOrderManage from "./pages/SystemDashboard/Orders/Manage/SystemOrderManage";
import OrderAssignment from "./pages/SystemDashboard/Orders/Manage/OrderAssignment";
import CustomerProfile from "./pages/SystemDashboard/Orders/Manage/CustomerProfile";
import OrderInformation from "./pages/SystemDashboard/Orders/Manage/OrderInformation";
import DashboardOrderManage from "./pages/CustomerDashboard/Orders/DashboardOrderManage";
import SystemLogs from "./pages/SystemDashboard/SystemLogs/SystemLogs";
import SystemOrderChat from "./pages/SystemDashboard/Orders/Manage/SystemOrderChat";
import PaymentStatus from "./pages/LandingPage/PaymentStatus/PaymentStatus";
import SystemTransactions from "./pages/SystemDashboard/SystemTransactions/SystemTransactions";

export const routes: RouteObject[] = [
    {
        path: '/',
        element: <AppLayout />,
        children: [
            {
                path: '', element: <Layout />, children: [
                    { path: '', element: <Branches /> },
                    { path: 'services', element: <Services /> },
                    { path: 'order', element: <OrderCreate /> },
                    { path: 'payment-status', element: <PaymentStatus /> },
                ]
            },
            { path: 'login', element: <Login /> },
            { path: 'forgot-password', element: <ForgotPassword /> },
            { path: 'register', element: <Register /> },
        ]
    },
    {
        path: '/dashboard',
        element: <CustomerDashboardLayout />,
        children: [
            { path: '', element: <DashboardProfile /> },
            {
                path: 'orders', element: <DashboardOrders />, children: [
                    { path: 'manage', element: <DashboardOrderManage /> }
                ]
            },
        ],
    },
    {
        path: '/system',
        element: <SystemDashboardLayout />,
        children: [
            { path: '', element: <Navigate to={'branches'} /> },
            {
                path: 'users', element: <SystemUsers />, children: [
                    { path: 'invite', element: <UserInvite /> }
                ]
            },
            {
                path: 'branches', element: <SystemBranches />, children: [
                    { path: 'create', element: <BranchCreate />, },
                    { path: 'update', element: <BranchUpdate />, },
                ]
            },
            {
                path: 'services', element: <SystemServices />, children: [
                    { path: 'create', element: <ServiceCreate />, },
                    { path: 'update', element: <ServiceUpdate />, },
                ]
            },
            { path: 'chat-bot', element: <SystemChatBot /> },
            { path: 'translations', element: <SystemTranslations /> },
            { path: 'live-chat', element: <SystemLiveChat /> },
            { path: 'orders', element: <SystemOrders /> },
            {
                path: 'orders/manage', element: <SystemOrderManage />, children: [
                    { path: 'info', element: <OrderInformation /> },
                    { path: 'customer', element: <CustomerProfile /> },
                    { path: 'assignment', element: <OrderAssignment /> },
                    { path: 'chat', element: <SystemOrderChat /> }
                ]
            },
            { path: 'transactions', element: <SystemTransactions /> },
            { path: 'logs', element: <SystemLogs /> },
            { path: 'profile', element: <SystemProfile /> },
        ]
    },
    {
        path: '/admin',
        element: <Navigate to={'/system'} />,
    },
]

export const router = createBrowserRouter(routes);